import React from 'react';

function DotsSix(props: object) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.6875 7.96875C5.11897 7.96875 5.46875 7.61897 5.46875 7.1875C5.46875 6.75603 5.11897 6.40625 4.6875 6.40625C4.25603 6.40625 3.90625 6.75603 3.90625 7.1875C3.90625 7.61897 4.25603 7.96875 4.6875 7.96875Z"
        fill="currentColor"
      />
      <path
        d="M10 7.96875C10.4315 7.96875 10.7812 7.61897 10.7812 7.1875C10.7812 6.75603 10.4315 6.40625 10 6.40625C9.56853 6.40625 9.21875 6.75603 9.21875 7.1875C9.21875 7.61897 9.56853 7.96875 10 7.96875Z"
        fill="currentColor"
      />
      <path
        d="M15.3125 7.96875C15.744 7.96875 16.0938 7.61897 16.0938 7.1875C16.0938 6.75603 15.744 6.40625 15.3125 6.40625C14.881 6.40625 14.5312 6.75603 14.5312 7.1875C14.5312 7.61897 14.881 7.96875 15.3125 7.96875Z"
        fill="currentColor"
      />
      <path
        d="M4.6875 13.5938C5.11897 13.5938 5.46875 13.244 5.46875 12.8125C5.46875 12.381 5.11897 12.0312 4.6875 12.0312C4.25603 12.0312 3.90625 12.381 3.90625 12.8125C3.90625 13.244 4.25603 13.5938 4.6875 13.5938Z"
        fill="currentColor"
      />
      <path
        d="M10 13.5938C10.4315 13.5938 10.7812 13.244 10.7812 12.8125C10.7812 12.381 10.4315 12.0312 10 12.0312C9.56853 12.0312 9.21875 12.381 9.21875 12.8125C9.21875 13.244 9.56853 13.5938 10 13.5938Z"
        fill="currentColor"
      />
      <path
        d="M15.3125 13.5938C15.744 13.5938 16.0938 13.244 16.0938 12.8125C16.0938 12.381 15.744 12.0312 15.3125 12.0312C14.881 12.0312 14.5312 12.381 14.5312 12.8125C14.5312 13.244 14.881 13.5938 15.3125 13.5938Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default DotsSix;
